import { CopyableCell } from "../../../common/functions";
import { longTitlesBO, mediumTitlesBO, smallTitlesBO } from "../../reports/tools/titlesPortfolio";
import { longTitlesFO, mediumTitlesFO, smallTitlesFO } from "../tools/titlesSummary";
import { width } from "../portfolio/viewSummary";
import { widthMobile, widthScreen } from "../../reports/portfolio/viewPortfolio";

function TopWorst(props: any) {
  // Flatten the selected groups into individual rows and rank them strictly by
  // the period's basis-point price move. Top = descending (biggest gainers),
  // worst = ascending (biggest losers), so the visible column is monotonic.
  let sortTitle = props.sortTitle;
  let direction = props.direction || "desc";
  let rows: any = [];
  (props.topWorst || []).forEach((group: any) => (group.data || []).forEach((position: any) => rows.push(position)));
  if (sortTitle) {
    rows.sort((a: any, b: any) => {
      let av = parseFloat(a[sortTitle]) || 0;
      let bv = parseFloat(b[sortTitle]) || 0;
      return direction == "desc" ? bv - av : av - bv;
    });
    rows = rows.slice(0, 10);
  }
  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
      }}
      className=" fadeIn table-container-custom"
    >
      <table id="" className="table table-hover table-summary">
        <tbody>
          <tr className="sticky-top">
            {props.titles.map((title: any, titleIndex: any) => {
              // Check if the title is one of the specified strings

              // If you need to keep the table structure consistent, render an empty <td>
              return (
                <td
                  key={titleIndex}
                  className={
                    props.view == "front office"
                      ? "copied-text " +
                        (titleIndex < 6 ? " higher-sticky-row " : " lower-sticky-row ") +
                        (longTitlesFO.includes(title) ? " wider-table-cell" : "") +
                        (titleIndex < 6 ? "higher-sticky-row" : "lower-sticky-row") +
                        (longTitlesFO.includes(title) ? " wider-table-cell" : "") +
                        (smallTitlesFO.includes(title) ? " small-table-cell" : "") +
                        (mediumTitlesFO.includes(title) ? " medium-table-cell" : "")
                      : "copied-text " +
                        (titleIndex < 10 ? " higher-sticky-row " : " lower-sticky-row ") +
                        (titleIndex < 10 ? " higher-sticky-portfolio-row  " : "") +
                        (longTitlesBO.includes(title) ? " wider-table-cell" : "") +
                        (longTitlesBO.includes(title) ? " wider-table-cell" : "") +
                        (smallTitlesBO.includes(title) ? " small-table-cell" : "") +
                        (mediumTitlesBO.includes(title) ? " medium-table-cell" : "")
                  }
                  style={{ left: props.view == "front office" ? (props.screenWidth < 1000 ? width[titleIndex + 1] : "") : props.screenWidth < 1000 ? widthMobile[titleIndex] : widthScreen[titleIndex] }}
                >
                  {title.startsWith("Mid ") ? "Mid" : title.startsWith("Yesterday's Mid") ? "Previous Mid" : title}
                </td>
              );
            })}
          </tr>
          {rows.map((position: any, positionIndex: any) => (
              <tr
                key={positionIndex}
                className="table-body"
                style={{ backgroundColor: `${position["Color"]}` }}
                onDoubleClick={(event) => props.getTrades(event, position)}
                id={"content" + "_" + props.idPrefix + "_" + positionIndex}
              >
                {props.titles.map((title: any, titleIndex: any) =>
                  props.view == "front office" ? (
                    <CopyableCell
                      key={titleIndex}
                      text={isFinite(position[title]) && position[title] ? position[title].toLocaleString() : position[title]}
                      index={titleIndex}
                      columns={6}
                      type={"summary"}
                      color={position["Color"]}
                      disabled={false}
                      left={props.screenWidth < 1000 ? width[titleIndex + 1] : ""}
                    />
                  ) : (
                    <CopyableCell
                      key={titleIndex}
                      text={isFinite(position[title]) && position[title] ? position[title].toLocaleString() : position[title]}
                      index={titleIndex}
                      columns={10}
                      type={"portfolio"}
                      color={position["Color"]}
                      left={props.screenWidth < 1000 ? widthMobile[titleIndex] : widthScreen[titleIndex]}
                    />
                  )
                )}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default TopWorst;
